import React, { useEffect, useState } from "react";
import Container from "../Common/Container";
import { ProductsProps } from "./interfaces/Products";
import Text from "../Common/Text";
import { CardV1 } from "./Components/ProductCards";
import { ProductsReq } from "./interfaces/ProductsRequest";
import { FiLoader } from "react-icons/fi";

const Products = ({
  data,
  onChange,
  ImageProvider,
}: {
  data: ProductsProps;
  onChange?: (value: any, id?: string) => void;
  ImageProvider: any;
}) => {
  const [productsData, setProductsData] = useState<ProductsReq | undefined>(
    undefined
  );

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    if (!data?.products?.api_key) {
      return;
    }

    let query = "";
    if (data?.products?.category) {
      query += `category=${data.products.category}`;
    }
    const response = await fetch(
      `${
        process.env.REACT_APP_API_DGS || process.env.NEXT_PUBLIC_API_DGS
      }/products?${query}`,
      {
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          api_key: data?.products?.api_key,
        },
      }
    ).catch((err) => {
      return null;
    });
    const products: ProductsReq = await response?.json();
    if (products) {
      setProductsData(products);
    }
    setLoading(false);
  };

  return (
    <Container className="my-10">
      <Text
        editor={!!onChange}
        id="Products"
        onChange={(val: any) => onChange?.(val, "title")}
      >
        {data?.title}
      </Text>

      {loading && (
        <div className="flex justify-center pt-10">
          <FiLoader className="animate-spin text-2xl text-[--primary600]"></FiLoader>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-5">
        {productsData?.data?.map((item) => (
          <CardV1
            key={item.id}
            {...item}
            config={data?.products}
            ImageProvider={ImageProvider}
          />
        ))}
      </div>
    </Container>
  );
};

export default Products;
